module.exports = __webpack_public_path__ + "img/ic_filter-01.0b9303d9.svg";